module.exports = __webpack_public_path__ + "img/wode_icon_daizhifu@3x.69230b7e.png";